import React, { Component, useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";

import { domainFunctions } from "../oro-module/domainFunctions";
import { FaCheck, FaEnvelopeOpenText } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { currencyCommas, sentenceCase, toTitleCase, camelCase, toDate, number2text, getObjectsValue } from "../oro-module/commonFunctions";
import UncontrolledTooltip from "reactstrap/lib/UncontrolledTooltip";


function convertBoxValues(boxvalue, displaytype) {
  if (displaytype == 'currency') {
    boxvalue = currencyCommas(boxvalue)
  }
  else if (displaytype == 'masked') {
    if (boxvalue) {
      boxvalue = 'XXXX' + boxvalue.substr(boxvalue.length - 4, boxvalue.length);
    }
  }
  else if (displaytype == 'percent') {
    boxvalue = boxvalue + "%";
  } else if (displaytype == 'date') {
    boxvalue = boxvalue ? toDate(boxvalue) : '';
  } else if (displaytype == 'capital' || displaytype == 'uppercase') {
    boxvalue = boxvalue.toUpperCase()
  } else if (displaytype == 'small') {
    boxvalue = displaytype ? boxvalue.toLowerCase() : displaytype;
  } else if (displaytype == 'sentencecase') {
    boxvalue = displaytype ? sentenceCase(boxvalue) : displaytype;
  } else if (displaytype == 'titlecase') {
    boxvalue = displaytype ? toTitleCase(boxvalue) : displaytype;
  } else if (displaytype == 'camelcase') {
    boxvalue = displaytype ? camelCase(boxvalue) : displaytype;
  } else if (displaytype == 'yesno') {
    boxvalue = (boxvalue && boxvalue != "") ? "YES" : "NO";
  }
  else if (displaytype == 'tick') {
    boxvalue = (boxvalue && boxvalue != "") ? <FaCheck style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644" }} /> : <MdClose style={{ fontSize: "12px", verticalAlign: "middle", borderColor: "black", color: "#2C3644", fontWeight: "bold" }} />;
  } else if (displaytype == 'cheque_status') {
    let def = { 0: 'OK', 1: 'Executed', 2: 'Already stopped', 3: 'Released', 4: 'Bounced', 5: 'Cancelled' };
    boxvalue = def[boxvalue];
  } else if (displaytype == 'in_words') {
    boxvalue = number2text(boxvalue);
  }

  return boxvalue;
}

const ShowDataCustom = (props) => {

  let { parentState } = props;
  let { name, style, font, isRequired, displaytype, data, formula, dheight, fixed, description, is_full_size } = props.component;
  let { pageData, LocalVars, modalname } = parentState;
  let [tooltipid, settooltipid] = useState(false);
  if (!style) {
    style = {};
  }
  if (!style.backgroundColor) { style.backgroundColor = "#F1F1F1"; }
  if (!style.color) { style.color = "#000000"; }
  if (displaytype && (['currency', 'date', 'percent'].indexOf(displaytype) != -1) && !style.textAlign) {
    style.textAlign = "right";
  }

  useEffect(() => {
    settooltipid("TTID" + String(Math.round(Math.random() * 1000000000)));
  }, [])

  // if (dheight == 'multiline') {
  //   style.whiteSpace = 'nowrap';
  // }

  let { compressed } = LocalVars;
  let boxvalue = fixed ? fixed : pageData[data];

  if (displaytype && (boxvalue || boxvalue == 0)) {
    boxvalue = convertBoxValues(boxvalue, displaytype);
  }

  return (
    <div
      className={`form-group  ${props.component.widths.parent}`}
      id={tooltipid ? tooltipid : 0}
    >

      {description && tooltipid &&
        <UncontrolledTooltip placement="bottom" target={tooltipid}>
          {description}
        </UncontrolledTooltip>
      }

      <div
        style={style}
        className={`${is_full_size ? 'hidescrollbar' : 'tinyscrollbar scrollable_showdata'} showdata ${!compressed ? 'showdatacustom-compressed' : "showdatacustom"}`}
      >
        {boxvalue ? boxvalue : ""}

      </div>

    </div>
  );
}


export default ShowDataCustom;
